
import baseLayout from '~/layouts/base';
import ErrorOverlay from '~/components/global/ErrorOverlay.vue';
export default {
    name: 'empty',
    components: { ErrorOverlay },
    extends: baseLayout,
};
